<template>
  <div class="page-header">
    <div class="config-nav-name" style="display:none">搜索</div>
    <div class="header-container">
      <img :src="emblem" class="logo cursor-pointer" @click="toHome" alt="网站Logo" />

      <div class="search-section">
        <div class="search-type-selector">
          <div
            v-for="type in searchTypes"
            :key="type.id"
            class="search-type-item"
            :class="{ active: searchIndex === type.id }"
            @click="changeSearchType(type.id)"
          >
            <span class="type-text">{{ type.name }}</span>
            <div class="type-indicator"></div>
          </div>
        </div>

        <div class="search-input-container">
          <SearchInput ref="searchInputRef" @searhKeyword="searhKeyword" :search-type="searchIndex"></SearchInput>
        </div>
      </div>

      <div class="shopping-cart-section">
        <div class="shopping-cart-btn" @click="gotoShoppingCart">
          <el-badge
            :value="shoppingCartNum > 99 ? '99+' : shoppingCartNum"
            class="cart-badge"
            :hidden="shoppingCartNum == 0"
          >
            <!-- <shoppingCart svg-name="shoppingCart" class="cart-icon"></shoppingCart> -->
            <i class="fas fa-shopping-cart"></i>
          </el-badge>
          <span class="cart-text">购物车</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from "./components/Search.vue";
import shoppingCart from "../common/UseSvg.vue";
import { mapState } from "vuex";

export default {
  components: {
    SearchInput,
    shoppingCart
  },
  data() {
    return {
      searchIndex: 1,
      searchTypes: [
        { id: 1, name: "关键字" },
        { id: 2, name: "VIN" }
      ]
    };
  },
  computed: {
    ...mapState("user", {
      shoppingCartNum: state => {
        return state.shoppingCartNum;
      }
    }),
    noLoginLook() {
      return this.$store.getters["companyInfo/noLoginLook"];
    },
    ...mapState("companyInfo", {
      emblem: state => {
        return state.emblem;
      }
    }),
    searchData() {
      return this.$store.getters["search/getSearchData"];
    },
    routerName() {
      return this.$route.name;
    }
  },
  watch: {
    searchData: {
      handler(newV) {
        // 首页搜索模块保持用户当前 tab，不被上次 VIN 会话把「关键字」切成 VIN
        if (this.routerName === "商品首页") {
          return;
        }
        if (newV.type > 0) {
          this.searchIndex = newV.type;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    gotoShoppingCart() {
      if (this.noLoginLook) {
        this.$router.push({
          path: "/login"
        });
        return;
      }
      this.$router.push({ path: "/new-products/shopping-car" });
    },
    toHome() {
      this.$router.push({ path: "/new-products" });
    },
    changeSearchType(type) {
      if (this.searchIndex !== type) {
        this.searchIndex = type;
        this.$refs.searchInputRef.clearInput();
      }
    },
    searhKeyword(payload) {
      // 兼容旧调用传字符串；历史查件传 { keyword, historyId, historyType, fromHistory }
      const data =
        typeof payload === "string"
          ? {
              keyword: payload,
              historyId: 0,
              historyType: "",
              fromHistory: false,
              type: this.searchIndex
            }
          : {
              keyword: payload.keyword || "",
              historyId: Number(payload.historyId || 0),
              historyType: payload.historyType || "",
              fromHistory: !!payload.fromHistory,
              type: payload.type || this.searchIndex
            };
      // 顶部搜索是全新查询：永远不带历史 areaId
      this.$store.commit("search/setSearchData", { ...data, areaId: 0 });
      if (this.routerName !== "商品列表") {
        this.$router.push({ path: "/new-products/product-list" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fa-shopping-cart {
  font-size: 25px;
  color: var(--color-primary);
}
.page-header {
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 12px;
}

.header-container {
  width: 100%;
  background-color: #fff;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  column-gap: 20px;

  .logo {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
}

.search-section {
  width: 750px;

  .search-type-selector {
    display: flex;
    justify-content: center;

    .search-type-item {
      position: relative;
      padding: 2px 6px;
      cursor: pointer;
      transition: all 0.3s ease;

      .type-text {
        font-size: 14px;
        font-weight: 500;
        color: #666;
        transition: all 0.3s ease;
        position: relative;
        z-index: 2;
      }

      .type-indicator {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        // background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-light80) 100%);
        background-color: var(--color-primary);
        // border-radius: 6px;
        opacity: 0;
        transform: scale(0.9);
        transition: all 0.3s ease;
        z-index: 1;
      }

      &:hover {
        .type-text {
          color: var(--color-primary);
        }
      }

      &.active {
        .type-text {
          color: white;
          font-weight: 600;
        }

        .type-indicator {
          opacity: 1;
          transform: scale(1);
        }
      }
    }
  }

  .search-input-container {
    width: 100%;
  }
}

.shopping-cart-section {
  .shopping-cart-btn {
    padding: 10px 16px;
    height: 46px;
    display: flex;
    align-items: center;
    column-gap: 12px;
    background: color-mix(in srgb, var(--color-light80) 20%, transparent) !important;
    // border: 2px solid rgba(79, 107, 255, 0.15);
    border: 2px solid var(--color-primary);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    // box-shadow: 0 2px 8px color-mix(in srgb, var(--color-primary-dark10) 5%, transparent);

    &:hover {
      border-color: color-mix(in srgb, var(--color-light80) 30%, transparent);
      box-shadow: 0 4px 12px color-mix(in srgb, var(--color-primary-dark10) 15%, transparent);
      transform: translateY(-1px);

      .cart-text {
        color: var(--color-primary);
      }

      .cart-icon {
        transform: scale(1.05);
      }
    }

    .cart-badge {
      ::v-deep .el-badge__content {
        background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
        border: 2px solid white;
        font-weight: 600;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }

    .cart-icon {
      width: 22px;
      height: 22px;
      transition: all 0.3s ease;
    }

    .cart-text {
      font-size: 14px;
      font-weight: 600;
      color: var(--color-primary);
      transition: all 0.3s ease;
    }
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .header-container {
    padding: 12px 16px;
    column-gap: 16px;
  }

  .search-section {
    width: 600px;
  }
}

@media (max-width: 768px) {
  .header-container {
    flex-wrap: wrap;
    row-gap: 12px;
    padding: 12px;

    .logo {
      width: 50px;
      height: 50px;
    }
  }

  .search-section {
    width: 100%;
    order: 3;

    .search-type-selector {
      .search-type-item {
        padding: 6px 12px;

        .type-text {
          font-size: 13px;
        }
      }
    }
  }

  .shopping-cart-section {
    margin-left: auto;

    .shopping-cart-btn {
      padding: 8px 12px;
      height: 40px;

      .cart-text {
        font-size: 13px;
      }
    }
  }
}

@media (max-width: 480px) {
  .header-container {
    padding: 10px 12px;
    column-gap: 12px;
  }

  .search-section .search-type-selector {
    .search-type-item {
      padding: 4px 10px;

      .type-text {
        font-size: 12px;
      }
    }
  }

  .shopping-cart-section .shopping-cart-btn {
    padding: 6px 10px;
    height: 36px;
    column-gap: 8px;

    .cart-text {
      font-size: 12px;
    }

    .cart-icon {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
